<template>
    <v-dialog
        v-model="visibleWindow"
        persistent
        width="1000"
    >
        <v-container 
            id="communication-window"
            fluid 
            >
            <v-layout column fill-height>
                <!-- Header -->
                <v-flex shrink>
                    <v-layout row align-center style="background-color: rgba(31, 81, 206, .3);">
    
                        <v-flex grow>
                            <div class="text-xs-center" style="font-weight: bold;">Messenger</div>
                        </v-flex>
                        <v-flex shrink>
                            <v-btn
                                icon
                                @click="closeWindow()"
                            >
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <!-- /Header -->

                <!-- Content -->
                <v-flex grow style="height: -webkit-fit-content;">
                    <v-layout row fill-height>
                        <!-- Personselection -->
                        <!-- <v-flex 
                            xs12
                            :sm6="selectedReceiver.receiverUserId != ''"
                            :sm8="selectedReceiver.receiverUserId == ''"
                            :md5="selectedReceiver.receiverUserId != ''"
                            :md6="selectedReceiver.receiverUserId == ''"
                            class="frame"
                            style="border-right: 2px solid rgb(230, 230, 230);" -->
                        <v-flex 
                            xs4
                            class="frame"
                            style="border-right: 2px solid rgb(230, 230, 230);"
                        >
                            <v-layout column fill-height >
                                <v-flex shrink class="frame" :class="[searchFocus ? 'blue-grey lighten-5' : '']">
                                    <v-layout row>
                                        <v-flex grow style="height: 100%;">
                                            <v-layout row align-center>
                                                <v-flex shrink style="padding-right: 5px;">
                                                    <v-tooltip bottom open-delay="600">
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon @click="$refs.search.focus()" v-on="on">{{$vuetify.icons.edit}}</v-icon>
                                                        </template>
                                                        <span>Empfänger auswählen, um neue Konversation zu starten.</span>
                                                    </v-tooltip>
                                                    
                                                </v-flex>
                                                <v-flex>
                                                    <v-text-field
                                                        style="font-size: 14px;"
                                                        ref="search"
                                                        v-model="search"
                                                        @focus="searchFocus = true"
                                                    >
                                                        <template v-slot:label>
                                                            <span style="font-size: 14px;">Suche nach Personen</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex shrink v-if="search != '' || searchFocus">
                                                    <v-btn icon @click="clearSearch()">
                                                        <v-icon x-small>cancel</v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    
                                </v-flex>
                                <v-divider></v-divider>
                                <v-flex grow style="height: -webkit-fit-content;">
                                        <v-layout column style="height: 100%">
                                            <!-- SearchListe -->
                                            <v-expand-transition>
                                                <div 
                                                    v-show="showSearchPersonSelection" 
                                                    style="position: relative; z-index: 100; height: 100%; overflow: hidden;"
                                                    class="blue-grey lighten-5 frame"
                                                >
                                                    <div style="display: block; z-index: 1;">
                                                        <div style="position: absolute; top: 0; left: 0; z-index: 100; width: 100%; height: 100%; overflow-x: hidden; overflow-y: scroll;">
                                                            
                                                            <v-layout column class="person-list">
                                                                <template v-for="(receiver, index) of sortedReceivers">
                                                                    <v-flex 
                                                                        :key="index + receiver.receiverUserId"
                                                                        shrink 
                                                                        v-ripple="{ class: `primary--text` }"
                                                                        class="person-list-item"  
                                                                        @click="addImportantReceiver(receiver)"  
                                                                    >
                                                                        <v-layout row align-center>
                                                                            <v-flex grow style="padding: 0 7px 0 0;">
                                                                                <v-layout column>
                                                                                    <v-flex style="white-space: nowrap;">
                                                                                        <span>{{receiver.salutation}} {{receiver.firstname}} {{receiver.lastname}}</span>
                                                                                    </v-flex>
                                                                                    <v-flex class="text-grey">
                                                                                        {{receiver.receiverEmail}}
                                                                                    </v-flex>
                                                                                    <v-flex>
                                                                                        <template v-for="(role, index) of receiver.roles">
                                                                                            {{role}}<template v-if="index < receiver.roles.length - 1">,</template>
                                                                                        </template>
                                                                                    </v-flex>
                                                                                    <v-flex v-if="receiver.isActivated == 0" shrink class="text-xs-xenter" style="white-space: nowrap;">
                                                                                        <span  style="background-color: orange; border-radius: 4px; padding: 0 4px;white-space: nowrap;">nicht aktiviert</span>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-flex>
                                                                            <v-flex v-if="receiver.unreadMessages > 0" shrink class="text-xs-xenter">
                                                                                <span class="badge">{{receiver.unreadMessages}}</span>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                </template>
                                                            </v-layout>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-expand-transition>
                                            <!-- /SearchListe -->

                                            <div 
                                                v-if="!showSearchPersonSelection" 
                                                style="position: relative; z-index: 100; height: 100%; overflow: hidden;"
                                            >
                                                <!-- <div style="display: block; position: relatice; z-index: 1;"> -->
                                                    <div style="display: block; z-index: 1;">
                                                        <div
                                                            style="position: absolute; top: 0; left: 0; z-index: 100; width: 100%; height: 100%; overflow-x: hidden; overflow-y: scroll;"
                                                        >
                                                            <v-layout v-if="importantReceivers.length > 0" column v-for="(receiver, index) of importantReceivers" :key="index + receiver.receiverUserId">
                                                                <v-flex
                                                                    shrink 
                                                                    v-ripple="{ class: `primary--text` }"
                                                                    class="person-list-item"
                                                                    :class="selectedReceiver.receiverUserId == receiver.receiverUserId ? 'active' : ''"   
                                                                    @click="selectReceiver(receiver)"    
                                                                >
                                                                    <v-layout row align-center>
                                                                        <v-flex grow style="padding: 0 7px 0 7px;">
                                                                            <v-layout column>
                                                                                <v-flex style="white-space: nowrap;">
                                                                                    <span>{{receiver.salutation}} {{receiver.firstname}} {{receiver.lastname}}</span>
                                                                                </v-flex>
                                                                                <v-flex class="text-grey">
                                                                                    {{receiver.receiverEmail}}
                                                                                </v-flex>
                                                                                <v-flex>
                                                                                    <template v-for="(role, index) of receiver.roles">
                                                                                        {{role}}<template v-if="index < receiver.roles.length - 1">,</template>
                                                                                    </template>
                                                                                </v-flex>
                                                                                <v-flex v-if="receiver.isActivated == 0" shrink class="text-xs-xenter" style="white-space: nowrap;">
                                                                                    <span  style="background-color: orange; border-radius: 4px; padding: 0 4px; white-space: nowrap;">nicht aktiviert</span>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                        <v-flex v-if="receiver.unreadMessages > 0" shrink class="text-xs-xenter" style="padding-right: 7px">
                                                                            <span class="badge">{{receiver.unreadMessages}}</span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                            <template v-if="importantReceivers.length == 0">
                                                                <v-layout column align-center class="text-xs-center">
                                                                    <v-flex style="padding: 24px;">Keine Konversationen vorhanden</v-flex>
                                                                    <v-flex style="padding: 24px;">
                                                                        Eine neue Konversation kann über die Suche nach Personen gestartet werden.
                                                                    </v-flex>
                                                                </v-layout>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                        <!-- /Personselection -->

                        <!-- Communication -->
                        <v-flex 
                            xs8
                            style="position: relative; z-index: 100; height: 100%; overflow: hidden;"
                            >
                            <v-layout column fill-height>
                                <v-flex shrink v-if="selectedReceiver.receiverUserId != ''" style="height: 75px; position: relative; z-index: 1000; width: 100%;">
                                    <v-layout column style="padding: 5px 7px; margin: 0;" class="person-list-item active">
                                        <v-flex style="white-space: nowrap;">
                                            <span>{{selectedReceiver.salutation}} {{selectedReceiver.firstname}} {{selectedReceiver.lastname}}</span>
                                        </v-flex>
                                        <v-flex class="text-grey">
                                            {{selectedReceiver.receiverEmail}}
                                        </v-flex>
                                        <v-flex>
                                            <template v-for="(role, index) of selectedReceiver.roles">
                                                {{role}}<template v-if="index < selectedReceiver.roles.length - 1">,</template>
                                            </template>
                                        </v-flex>
                                        <v-flex v-if="selectedReceiver.isActivated == 0" shrink class="text-xs-xenter" style="white-space: nowrap;">
                                            <span  style="background-color: orange; border-radius: 4px; padding: 0 4px;white-space: nowrap;">nicht aktiviert</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex grow order-xs2 style="display: block; position: relative; z-index: 1;">
                                    <div id="messages" style="position: absolute; top: 0; left: 0; z-index: 100; width: 100%; height: 100%; overflow-x: hidden; overflow-y: scroll;">
                                        <!-- <v-layout id="messages" column style="max-height: 498px; overflow-y: auto; height: 100%"> -->
                                        <v-layout column>
                                            <template v-if="sortedMessages.length > 0">
                                                <v-flex v-for="(message, index) of sortedMessages" :key="message.messageId" shrink :id="index+1 == messages.length? 'lastMessage' : ''">
                                                    <v-card style="margin: 5px;">
                                                        <v-card-title style="background-color: rgba(31, 81, 206, .1);">
                                                            <v-layout column>
                                                                <v-flex>
                                                                    <v-layout row>
                                                                        <v-flex :class="[ message.senderEmail == selectedReceiver.receiverEmail ? 'text-xs-left' : 'text-xs-right']">
                                                                            <template v-if="message.senderEmail == selectedReceiver.receiverEmail">
                                                                                Empfangen am {{message.date}} um {{message.time}} Uhr
                                                                            </template>
                                                                            <template v-else>
                                                                                Gesendet am {{message.date}} um {{message.time}} Uhr
                                                                            </template>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-layout column>
                                                                <v-flex shrink style="
                                                                    padding-bottom: 5px; 
                                                                    border-bottom: 1px solid rgb(210,210,210); 
                                                                    word-break: break-word;
                                                                    white-space: break-spaces;
                                                                    "
                                                                >
                                                                    <span style="font-weight: bold;">{{message.subject}}</span>
                                                                </v-flex>
                                                                <v-flex grow style="white-space: break-spaces;">
                                                                    <span>{{message.message}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </template>
                                            <!-- <template v-else>
                                                <v-flex style="height: 100%" class="text-xs-center">
                                                    <v-layout align-center fill-height row>
                                                        <v-flex v-if="selectedReceiver.receiverUserId == ''">
                                                            Bitte wählen Sie eine Person aus
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </template> -->
                                        </v-layout>
                                    </div>
                                    
                                </v-flex>

                                <v-flex 
                                    shrink
                                    order-xs3
                                    :id="selectedReceiver.receiverUserId !== '' ? 'send-message-window' : ''"
                                    style="position: relative; z-index: 1; min-height: 180px;"
                                >
                                    <v-layout column>
                                        <v-expand-transition>
                                            <v-flex shrink v-show="errorMsg !== ''">
                                                <v-alert :value="true">
                                                    {{errorMsg}}
                                                </v-alert>
                                            </v-flex>
                                        </v-expand-transition>
                                        
                                        <v-flex grow>
                                            
                                            <v-layout v-show="selectedReceiver.receiverUserId !== ''" row align-center>

                                                <v-flex grow>
                                                    <v-form ref="msg">
                                                        <v-layout column>
                                                            <v-flex shrink>
                                                                <v-text-field
                                                                    flat
                                                                    style="font-size: 14px;"
                                                                    class="textfield"
                                                                    hide-details
                                                                    :rules="[rules.required]"
                                                                    v-model="message2Send.subject"
                                                                >
                                                                    <template v-slot:label>
                                                                        <span style="font-size: 14px;">Betreff</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex grow>
                                                                <v-textarea
                                                                    flat
                                                                    class="textfield"
                                                                    style="font-size: 14px;"
                                                                    no-resize
                                                                    :rules="[rules.required]"
                                                                    hide-details
                                                                    v-model="message2Send.message"
                                                                >
                                                                    <template v-slot:label>
                                                                        <span style="font-size: 14px;">Nachricht</span>
                                                                    </template>
                                                                </v-textarea>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-form>
                                                </v-flex>

                                                <v-flex shrink>
                                                    <v-tooltip bottom open-delay="600">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn 
                                                                icon
                                                                @click="sendMessage()"
                                                                v-on="on"
                                                                >
                                                                <v-layout column justify-center align-center>
                                                                    <v-flex>
                                                                        <v-icon id="send-button">
                                                                            send
                                                                        </v-icon>
                                                                    </v-flex>
                                                                    <!-- <v-flex class="text-xs-center" style="padding: 0 4px; color: white; font-size: 12px; width: 130px;">
                                                                        <div>Senden</div>
                                                                    </v-flex> -->
                                                                </v-layout>
                                                            </v-btn>
                                                        </template>
                                                        <span>Nachricht versenden und Empfänger per E-Mail benachrichtigen.</span>
                                                    </v-tooltip>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <!-- /Communication -->
                    </v-layout>
                </v-flex>
                <!-- /Content -->
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>

export default {
    name: 'CommunicationWindow',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
    },

    data: () => ({

        search: '',
        searchFocus: false,

        rules: {
            required: value => !!value || 'Dieses Feld ist erforderlich.',
        },

        selectedReceiver: {
            receiverUserId: '',
            receiverEmail: ''
        },

        receiverSearchKeys: [
            'salutation',
            'title',
            'firstname',
            'lastname',
            'receiverEmail',
            'roles'
        ],

        message2Send: {
            subject: '',
            message: ''
        },

        visibleWindow: false,

        importantReceivers: [],

        receivers: [],
        messages: [],

        sendPressed: false

    }),

    watch: {
        sortedMessages() {
            setTimeout(() => {
                this.scrollToLast()
            }, 1, this);
            ;
        },
        visibleWindow(visible) {
            if(!visible) this.closeWindow();
        },
        visible(visible) {
            this.searchFocus = false;

            if(visible) {
                this.fetchReceivers();
                this.visibleWindow = visible;
            }

            this.importantReceivers = [];
            
            this.selectedReceiver = {
                receiverUserId: '',
                receiverEmail: ''
            }
            
            this.messages = [];
        }
    },

    mounted() {
        this.setImportantReceivers();
        
    },

    computed: {
        errorMsg() {
            if(this.selectedReceiver.receiverUserId && this.sendPressed && (!this.message2Send.subject || !this.message2Send.message)) {
                return 'Die rot markierten Felder müssen ausgefüllt werden.';
            } else {
                this.sendPressed = false;
                return '';
            }
        },
        showSearchPersonSelection() {
            return this.searchFocus//this.search.trim() !== '';
        },

        sortedMessages() {
            let array = [];
            if(this.messages.length > 0 ) {
                array = this.messages.map(message => {
                    let date = new Date(message.creationTime);
                    let hours = `${date.getHours()}`.length == 1 ? `0${date.getHours()}` : date.getHours();
                    let minutes = `${date.getMinutes()}`.length == 1 ? `0${date.getMinutes()}` : date.getMinutes();
                    return Object.assign(message, {
                        date: date.toLocaleDateString('de-DE', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }),
                        time: `${hours}:${minutes}`
                    })
                })
            }
            return array;
        },

        preparedReceivers() {
            let array = [];

            for(let receiver of this.receivers) {
                let obj = {};
                for(let key of this.receiverSearchKeys) {
                    if(receiver[key]) obj[key] = receiver[key];
                }

                if(JSON.stringify(Object.values(obj)).toLowerCase().includes(this.search.toLowerCase())) {
                    array.push(receiver);
                }
            }


            return array;

        },

        sortedReceivers() {
            let activatedReceivers = this.preparedReceivers.filter(receivers => receivers.isActivated == 1);
            let notActivatedReceivers = this.preparedReceivers.filter(receivers => receivers.isActivated == 0);

            let sortedActivatedReceivers = activatedReceivers.sort((rec1, rec2) => {
                return (rec1.lastname).localeCompare(rec2.lastname);
            });

            let sortedNotActivatedReceivers = notActivatedReceivers.sort((rec1, rec2) => {
                return (rec1.receiverEmail).localeCompare(rec2.receiverEmail);
            });

            return activatedReceivers.concat(sortedNotActivatedReceivers);
        }
    },

    methods: {
        closeSearch() {
            setTimeout( () => {
                this.searchFocus = false;
            } , 100, this)
        },
        closeWindow() {
            this.visibleWindow = false;
            this.$emit('close');
        },
        scrollToLast(timeout = 0) {
            if(!!document.getElementById('lastMessage')) {
                this.$vuetify.goTo('#lastMessage', {
                    duration: timeout,
                    offset: 0,
                    easing: 'easeInOutCubic',
                    container: '#messages'
                });
            }
        },
        sortReceivers(receivers) {
            return receivers.sort((a, b) => {
                if(a.messagesLastDate == null) return -1;
                else if(b.messagesLastDate == null) return 1;

                let aDate = new Date(a.messagesLastDate);
                let bDate = new Date(b.messagesLastDate);

                return aDate.getTime() <= bDate.getTime() ? 1 : -1;
            });
        },
        switchArrayposition(array, fromIndex, toIndex) {
            let newArray = JSON.parse(JSON.stringify(array));
            let tmp = array[fromIndex];
            newArray[fromIndex] = newArray[toIndex];
            newArray[toIndex] = tmp;
            return newArray;
        },

        selectReceiver(receiver) {
            if(this.selectReceiver.receiverUserId != '') {
                this.message2Send = {
                    subject: '',
                    message: ''
                }
                this.$refs.msg.reset();
            }
            this.selectedReceiver = receiver;
            this.sendPressed = false
            
            //this.$emit('select', receiver);
            this.fetchMessages(receiver.receiverUserId);
        },

        addImportantReceiver(receiver) {
            this.selectReceiver(receiver);

            const importantReceiversHasReceiver = this.importantReceivers.filter(importantReceiver => importantReceiver.receiverUserId == receiver.receiverUserId).length > 0;
            
            
            if(!importantReceiversHasReceiver) {
                let array = JSON.parse(JSON.stringify(this.importantReceivers));
                array = array.filter(receiver => receiver.messagesCount > 0);
                array.push(receiver)
                this.importantReceivers = this.sortReceivers(array);
            }

            console.log(receiver, importantReceiversHasReceiver)

            this.clearSearch();
        },

        removeImportantReceiver(receiver) {
            const receiverIndex = -1;

            this.importantReceivers.forEach((importantReceiver, index) => {
                if(importantReceiver.receiverUserId == receiver.receiverUserId) receiverIndex = index;
            });

            if(receiverIndex > -1) this.importantReceivers.splice(receiverIndex, 1);
            
        },

        setImportantReceivers() {
            let filtered = this.receivers.filter(receiver => receiver.messagesCount > 0);
            this.importantReceivers =  this.sortReceivers(filtered);
        },

        sendMessage() {
            this.sendPressed = true;

            let payload = {
                receiverUserId: this.selectedReceiver.receiverUserId
            }
            this.$refs.msg.validate();
            if(this.errorMsg == '') {
                //this.$emit('send', Object.assign({}, receiver, msg))
                
                this.insertMessage(Object.assign(payload, this.message2Send));

                this.message2Send = {
                    subject: '',
                    message: ''
                }
            }
            
        },

        clearSearch() {
            this.searchFocus = false
            this.search = '';
            this.$refs.search.blur();
        },

        fetchReceivers() {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/messages/receivers",
                method: 'POST',
                data: {
                    userRole: self.$store.state.userRole.role,
                    clientId: this.$store.state.currentClient.clientId
                },
                blockGui: false,
                success: function(response) {
                    self.setReceivers(response.data.receivers);
                }
            })
        },

        setReceivers(receivers) {
            let array = [];
            for(let receiver of receivers) {
                let obj = receiver;
                obj.fullname = receiver.firstname + ' ' + receiver.lastname;
                obj.fullSalutation = receiver.salutation + ' ' + obj.fullname;
                obj.roles = receiver.roles.sort();
                obj.rolesString = receiver.roles.join(", ");
                array.push(obj);
            }
            this.receivers = array;
            this.setImportantReceivers();
        },

        fetchMessages(targetUserId) {
            let self = this;
            this.axios.axiosCall({
                url: `${actionUrl}rest/messages/${this.$store.state.currentClient.clientId}/${targetUserId}`,
                method: "GET",
                data: {},
                success: (response) => {
                    self.setMessages(response.data.messages);
                }
            });
        },

        setMessages(messages) {
            this.messages = messages;
            this.scrollToLast();
            const memessagesContainsUnreadMessages = this.selectedReceiver.unreadMessages > 0;
            if(memessagesContainsUnreadMessages) {
                this.readMessages(this.selectedReceiver.receiverUserId);
                
            }
        },

        insertMessage({receiverUserId, subject, message}) {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/messages",
                method: 'POST',
                data: {
                    clientId: this.$store.state.currentClient.clientId,
                    receiverUserId,
                    subject,
                    message
                },
                success: function(response) {
                    self.fetchMessages(self.selectedReceiver.receiverUserId);
                    self.fetchReceivers();
                }
            })
            this.$refs.msg.reset();
        },

        readMessages(receiverUserId) {
            this.updateMessageState(receiverUserId);
        },

        updateMessageState(receiverUserId) {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/messages/state",
                method: 'POST',
                data: {
                    clientId: this.$store.state.currentClient.clientId,
                    senderUserId: receiverUserId
                },
                success: function(response) {
                    self.fetchReceivers();
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#communication-window {
    padding:0; 
    background-color: white; 
    border-radius: 2px;
    height: 80vh;

    #send-message-window {
        background-color: #DFE7F8;
        padding: 5px;
    }

    #send-button {
        transform: rotate(-30deg);
    }

    & .person-list {

        &-item {
            padding: 4px;
            margin-bottom: 7px;
            cursor: pointer;

            &:hover {
                background-color: rgba(0,0,0,0.05);
            }

            &.active {
                // background-color: rgba(0,0,0,0.15);
                background-color: #DFE7F8;
            }
        }
    }
}

.badge {
    color: #fff;
    background-color: red;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    border-radius: 50%;
    height: 22px;
    width: 22px;
    justify-content: center;
    align-items: center;
}

.text-grey {
    color: #889;
}

.textfield {
    background-color: white; border-radius: 4px;
}

.frame {
    padding: 8px;
}

</style>